import { animate, style, transition, trigger } from '@angular/animations';

export const mainMenuFade = trigger('mainMenuFade', [
    transition(':enter', [
        style({ opacity: 0, position: 'absolute', left: 0, right: 0, top: 0, margin: 'auto' }),
        animate('200ms 300ms ease-in', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        style({ opacity: 1, position: 'absolute', left: 0, right: 0, top: 0, margin: 'auto' }),
        animate('200ms ease-out', style({ opacity: 0 }))
    ])
]);
